export default function cleanData(obj: any): any {
  for (const key in obj) {
    if (obj[key] === undefined) {
      obj[key] = "";
    }

    if (obj[key] && typeof obj[key] === "object") {
      obj[key] = cleanData(obj[key]);
    }
  }
  return obj;
}
